/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Modal,
  Row,
  Select,
  Table,
  Tooltip,
  message,
} from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import PageHeading from "../../../components/common/PageHeading";
import RightBar from "../../../components/common/RightBar";
import ConfirmationBox from "../../../components/common/ConfirmationBox";

import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";
import { vacncsproperties } from "../../../data/vacancies";
import { propertiesunitscampaigns } from "../../../data/guestcards";
import TextArea from "antd/es/input/TextArea";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { auth, db } from "../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

function UnitTurns() {
  const [expended, setExpended] = useState();
  const [user, loading] = useAuthState(auth);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isShowMore, setIsShowMore] = useState(false);
  const [isSortByAsc, setIsSortByAsc] = useState(false);
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);
  const [properties, setProperties] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [isEditModalOpen, setEditIsModalOpen] = useState(false);
  const [isDelModalOpen, setDeIsModalOpen] = useState(false);
  const [companyName, setcompanyName] = useState("");
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const editParam = searchParams.get("edit");
  const deleteParam = searchParams.get("del");

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  const showEditModal = () => {
    setEditIsModalOpen(true);
  };
  const showDelModal = () => {
    setDeIsModalOpen(true);
  };
  const updateUnitTurnStatus = async (editParams, data) => {
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const userRef = collection(companyDocRef, "unitTurns");
    try {
      const querySnapshot = await getDocs(userRef);
      querySnapshot.forEach((doc) => {
        if (doc.id === editParams) {
          const docRef = doc.ref;

          updateDoc(docRef, {
            status: "Completed",
          });
        }
      });
      message.success("unit to rent ready. ", 3);
    } catch (error) {
      console.error("Error updating unitTurns status:", error);
      message.error("Something went wrong!", 3);
    }
  };

  const deleteUnitTurn = async (editParams) => {
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const userRef = collection(companyDocRef, "unitTurns");

    try {
      const querySnapshot = await getDocs(userRef);
      querySnapshot.forEach((doc) => {
        if (doc.id === deleteParam) {
          const docRef = doc.ref;
          deleteDoc(docRef);
        }
      });
      message.success("Unit turn deleted successfully.", 3);
    } catch (error) {
      console.error("Error deleting unit turn:", error);
      message.error("Something went wrong!", 3);
    }
  };
  const handleOk = () => {
    updateUnitTurnStatus(editParam);
    // setIsModalOpen(false);
    setEditIsModalOpen(false);
  };
  const handleDeleteOk = () => {
    deleteUnitTurn(deleteParam);
    // setIsModalOpen(false);
    setDeIsModalOpen(false);
  };
  const handleCancel = () => {
    // setIsModalOpen(false);
    setEditIsModalOpen(false);
    setDeIsModalOpen(false);
  };
  const UnitTurnsRightBar = [
    RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
      RightBarMethod(
        <span>
          New Unit Turn
        </span>,
        "1",
        "",
        "",
        ""
      ),
      RightBarMethod(
        "New Recurring Work Order",
        "2",
        "",
        "",
        "/maintenance/recurring-work-orders/new"
      ),
    ]),

    RightBarMethod(
      " REPORTS",
      "t2",
      <i className="fa-solid fa-chart-column"></i>,
      [RightBarMethod("Unit Turn Detail", "3", "", "", "")]
    ),

    RightBarMethod(
      " HELP TOPICS",
      "t3",
      <i className="fa-solid fa-circle-question"></i>,
      [RightBarMethod("Using the Turn Board", "4", "", "", "/")]
    ),
  ];
  const getUnitTurns = async (company) => {
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertiesRef = collection(companyDocRef, "unitTurns");
      const querySnapshot = await getDocs(propertiesRef);

      const propertiesData = [];
      querySnapshot.forEach((doc) => {
        const property = { id: doc.id, ...doc.data() };
        propertiesData.push(property);
      });

      setProperties(propertiesData);
      setSearchData(propertiesData);

      console.log("Properties:", propertiesData);
    } catch (error) {
      console.log("Error getting properties:", error);
    }
  };

  const getTenant = async () => {
    try {
      const companiesRef = collection(db, "companies");
      const companyDocRef = doc(companiesRef, companyName);
      const propertiesRef = collection(companyDocRef, "tenants");
      const querySnapshot = await getDocs(propertiesRef);

      const propertiesData = [];
      querySnapshot.forEach((doc) => {
        const property = { id: doc.id, ...doc.data() };
        propertiesData.push(property);
      });

      const filteredTenants = propertiesData.filter((tenant) =>
        properties.some((prop) => prop.unitId === tenant.propertyId)
      );

      setTenants(filteredTenants);
      console.log("Filtered Tenants:", filteredTenants);
    } catch (error) {
      console.log("Error getting properties:", error);
    }
  };

  const gridStyle = {
    textAlign: "center",
  };

  const settingToolTip = (
    <div style={{ color: "#000" }}>
      <h4 style={{ marginTop: 0 }}>Unit Turn Board Settings</h4>
      <span>
        Specify default or property-specific settings for your unit turn board.
      </span>
    </div>
  );

  const expend = (index) => {
    if (expended === index) setExpended(undefined);
    else setExpended(index);
  };

  const items = [
    {
      label: (
        <a onClick={() => alert("Mark as Completed ")}>Mark as Completed</a>
      ),
      key: "0",
    },
    {
      label: (
        <a onClick={() => alert("Edit Availability Date ")}>
          Edit Availability Date
        </a>
      ),
      key: "1",
    },
    {
      label: <a onClick={() => alert("Edit Note")}>Edit Note</a>,
      key: "2",
    },
    {
      label: <a onClick={() => alert("Delete ")}>Delete</a>,
      key: "2",
    },
  ];

  const handleSortBy = (value) => {
    console.log(`selected ${value}`);
  };

  const sortByList = [
    {
      value: "MoveOut",
      label: "Move Out",
    },
    {
      value: "MoveIn",
      label: "Move In",
    },
    {
      value: "UnitName",
      label: "Unit Name",
    },
    {
      value: "Targetdate",
      label: "Target Date",
    },
  ];

  const handleShowMoreBtn = () => {
    setIsShowMore(!isShowMore);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const tableTopHeader = [
    {
      title: (
        <div>
          <Dropdown
            menu={{ items }}
            trigger={["click"]}
            className="workOrderSavedFilters"
          >
            <a onClick={(e) => e.preventDefault()}>
              Bulk Actions
              <DownOutlined />
            </a>
          </Dropdown>
          <span style={{ fontWeight: "100" }}>
            {" "}
            {selectedRowKeys.length} Selected
          </span>
          <div style={{ float: "right" }}>
            <label htmlFor="sortby">Sort By </label>
            <Select
              defaultValue={sortByList[0]}
              style={{
                width: 120,
              }}
              onChange={handleSortBy}
              options={sortByList}
            />
            <span onClick={() => setIsSortByAsc(!isSortByAsc)}>
              {isSortByAsc ? (
                <UpOutlined style={{ marginLeft: "5px", cursor: "pointer" }} />
              ) : (
                <DownOutlined
                  style={{ marginLeft: "5px", cursor: "pointer" }}
                />
              )}
            </span>
          </div>
        </div>
      ),
      children: [
        {
          dataIndex: "serviceRequest",
          width: "100%",
        },
      ],
    },
  ];
console.log("searchData",searchData)
  const tableAllData = [];
  for (let i = 0; i < searchData.length; i++) {
    tableAllData.push({
      key: i,
      serviceRequest: (
        <div>
          <Row>
            <Col span={24}>
              <Link to={`/maintenance/unit-turns/${searchData[i].id}`}>{searchData[i].unitName}</Link>
            </Col>
          </Row>
          <Row>
            <Col span={5}>
              <div>
                Move Out: <span>{tenants[i]?.tenantStatus?.moveOutDate}</span>
              </div>
            </Col>
            <Col span={5}>
              <div>
                Move In: <span>{tenants[i]?.tenantStatus?.moveInDate}</span>
              </div>
            </Col>
            <Col span={10}>
              <div>
                Target Turnaround Date:{" "}
                <span style={{ color: "red" }}>9/13/2022 (4 months ago)</span>
              </div>
            </Col>
          </Row>
          <br />
          <Row>
            <Col span={4}>
              <div>
                <p>Maintenance / Repair</p>
                <span>--</span>
              </div>
            </Col>
            <Col span={2}>
              <div>
                <p>Paint</p>
                <span>--</span>
              </div>
            </Col>
            <Col span={3}>
              <div>
                <p>Appliances</p>
                <span>--</span>
              </div>
            </Col>
            <Col span={4}>
              <div>
                <p>Floors / Carpets</p>
                <span>--</span>
              </div>
            </Col>
            <Col span={2}>
              <div>
                <p>Other</p>
                <span>--</span>
              </div>
            </Col>
            <Col span={3}>
              <div>
                <p>Housekeeping</p>
                <span>--</span>
              </div>
            </Col>
            <Col span={3}>
              <div>
                <p>Keys / Locks</p>
                <span>--</span>
              </div>
            </Col>
            <Col span={2}>
              <div>
                {!isShowMore ? (
                  <a onClick={handleShowMoreBtn}>Show 4 more</a>
                ) : (
                  <>
                    <p>Gutters</p>
                    <span>--</span>
                  </>
                )}
              </div>
            </Col>
            <Col span={1}>
              <div style={{ textAlign: "right" }}>
                <a onClick={() => expend(i)}>
                  {i === expended ? <UpOutlined /> : <DownOutlined />}
                </a>
              </div>
            </Col>
          </Row>
          {isShowMore && (
            <Row>
              <Col span={3}>
                <div>
                  <p>Exterior Paint</p>
                  <span>--</span>
                </div>
              </Col>
              <Col span={3}>
                <div>
                  <p>Pest Control</p>
                  <span>--</span>
                </div>
              </Col>
              <Col span={3}>
                <div>
                  <p>Windows</p>
                  <span>--</span>
                </div>
              </Col>
              <Col span={2}>
                <div>
                  <a onClick={handleShowMoreBtn}>Hide 4 categories</a>
                </div>
              </Col>
            </Row>
          )}
        </div>
      ),
    });
  }

  const searchByStatus = (value) => {
    console.log(`selected ${value}`);
    const filteredData = properties.filter((post) => {
      if (value === "") return true;
      return post.status.toLowerCase().includes(value.toLowerCase());
    });
    console.log("filteredData", filteredData);

    setSearchData(filteredData); // Assuming you have a setSearchData function to set the state
  };

  const searchUnit = (value) => {
    console.log(`selected ${value}`);
    const results = properties.filter((post) => {
      if (value === "" || value === undefined) return post;
      return post.unitName.toLowerCase().includes(value.toLowerCase());
    });
    console.log("results", results);
    setSearchData(results);
  };
  const searchByMoveOutDateRange = (value) => {
    console.log(`selected ${value}`);
    const results = properties.filter((post) => {
      if (value === "") return post;
      return post.status.toLowerCase().includes(value.toLowerCase());
    });
    console.log("results", results);
  };
  const dateFormat = ["MM/DD/YYYY", "MM/DD/YY"];
  useEffect(() => {
    console.log("unit Turns UseEffect....");
    getUnitTurns();
    getTenant();
    fetchCompanyName();
  }, [companyName]);
  // useEffect(() => {
  //   console.log("Edit Parameter..", editParam);

  //   // updateUnitTurnStatus(editParam);
  // }, [editParam]);
  return (
    <>
      <div>
        <PageHeading heading="Unit Turns" />
        <Row>
          <Col span={24}>
            <Card title="Key Metrics" bordered={false}>
              <div className="cardBody" style={gridStyle}>
                <p>--</p>
                <p style={{ color: "#5b707e" }}>Average days on a turn</p>
              </div>
            </Card>
          </Col>
        </Row>
        <br />
        <Row>
          <Col span={24}>
            <Card
              title="Unit Turn Board"
              bordered={false}
              extra={
                <div>
                  <Tooltip
                    placement="bottom"
                    title={settingToolTip}
                    trigger={["click"]}
                    color={["#fff"]}
                  >
                    <a>
                      <i className="fa-solid fa-circle-question"></i>
                    </a>
                  </Tooltip>
                  <a href="#"> Settings</a>
                </div>
              }
            >
              <div className="cardBody" style={gridStyle}>
                <Row>
                  <Col span={5} style={{ textAlign: "left" }}>
                    <label
                      htmlFor="filterByStatus"
                      className="labelForVendorInputs"
                    >
                      Status
                    </label>
                    <Select
                      defaultValue="InProgress"
                      style={{
                        width: "100%",
                      }}
                      onChange={searchByStatus}
                      options={[
                        {
                          value: "In Progress",
                          label: "In Progress",
                        },
                        {
                          value: "Completed",
                          label: "Completed",
                        },
                      ]}
                    />
                  </Col>
                  <Col span={8} style={{ textAlign: "left" }} offset={1}>
                    <label
                      htmlFor="filterByProperty"
                      className="labelForVendorInputs"
                    >
                      Filter By
                    </label>
                    <Select
                      showSearch
                      allowClear
                      style={{
                        width: "100%",
                      }}
                      placeholder="Unit, Property, Property Group, or Portfolio"
                      onChange={searchUnit}
                      options={properties.map((tenant) => ({
                        value: tenant.unitName,
                        label: tenant.unitName,
                      }))}
                    />
                  </Col>
                  <Col span={9} style={{ textAlign: "left" }} offset={1}>
                    <Row justify="space-between">
                      <Col span={24}>
                        <label
                          htmlFor="filterByDateRange"
                          className="labelForVendorInputs"
                        >
                          Move-out Date Range
                        </label>
                      </Col>
                      <Col span={10}>
                        <DatePicker
                          format={dateFormat}
                          style={{ width: "100%" }}
                          placeholder="Start date"
                        />
                      </Col>
                      <Col span={2} offset={1}>
                        to
                      </Col>
                      <Col span={10}>
                        <DatePicker
                          format={dateFormat}
                          style={{ width: "100%" }}
                          placeholder="End date"
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <br />
                <Table
                  rowSelection={rowSelection}
                  columns={tableTopHeader}
                  dataSource={tableAllData}
                  expandable={{
                    expandedRowRender: (_, i) => (
                      <div>
                        <ul style={{ display: "flex" }}>
                          <li
                            style={{
                              borderRight: "1px solid rgba(35,68,90,.15)",
                              padding: "0px 10px",
                            }}
                          >
                            <a href="/">Create Work Order</a>
                          </li>
                          <li
                            style={{
                              borderRight: "1px solid rgba(35,68,90,.15)",
                              padding: "0px 10px",
                            }}
                          >
                            {/* {searchData.map((item) => ( */}
                            <NavLink
                              to={`?edit=${searchData[i].id}`}
                              onClick={showEditModal}
                            >
                              Mark as Completed
                            </NavLink>
                            {/* ))} */}
                          </li>
                          <li style={{ padding: "0px 10px" }}>
                            <NavLink
                              to={`?del=${searchData[i].id}`}
                              onClick={showDelModal}
                              style={{ color: "red" }}
                            >
                              Delete
                            </NavLink>
                          </li>
                        </ul>
                      </div>
                    ),
                    expandIcon: () => null,
                  }}
                  expandedRowKeys={[expended]}
                  footer={false}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={UnitTurnsRightBar} />
      </div>
      {isConfirmationBoxOpen ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
          <h2>Create a New Unit Turn</h2>

          <Form layout="vertical">
            <Form.Item label="Unit" required>
              <Select
                options={propertiesunitscampaigns}
                placeholder="Search by Units"
              />
            </Form.Item>
            <Form.Item label="Notes" name="unitDescription">
              <TextArea rows={3} />
            </Form.Item>
            <div className="action-buttons">
              <Button type="primary" htmlType="submit">
                Create
              </Button>
              <button
                className="cancel-btn"
                onClick={() => setIsConfirmationBoxOpen(false)}
              >
                Cancel
              </button>
            </div>
          </Form>
          <div className="action-buttons">
            <Button
              type="primary"
              onClick={() => setIsConfirmationBoxOpen(false)}
            >
              Create
            </Button>
            <button
              className="cancel-btn"
              onClick={() => setIsConfirmationBoxOpen(false)}
            >
              Cancel
            </button>
          </div>
        </ConfirmationBox>
      ) : null}

      <Modal
        title="Mark As Completed"
        open={isEditModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>
          Marking this unit turnover as complete will also automatically switch
          the unit to rent ready. Are you sure you want to continue?
        </p>
      </Modal>
      <Modal
        title="Delete this unit turn"
        open={isDelModalOpen}
        onOk={handleDeleteOk}
        onCancel={handleCancel}
      >
        <p>
          Deleting this unit turn will permanently delete it from the turn
          board. Are you sure you want to continue?
        </p>
      </Modal>
    </>
  );
}

export default UnitTurns;
